export const components = {
  emptyState: {
    primaryTitle: 'Oups!',
    primaryText: 'Rien à afficher pour le moment…',
    secondaryTitle: 'Rien à afficher',
    secondaryText: "Malheureusement, il n'y a aucun élément à afficher en fonction des filtres appliqués…"
  },
  filters: {
    all: 'Tout',
    search: 'Recherche',
    priceRange: 'Plage de prix {currency}',
    minValue: 'La valeur minimale est {val} !',
    maxValue: 'La valeur maximale est {val} !',
    reset: 'Réinitialiser',
    apply: 'Appliquer'
  },
  comments: {
    reply: 'Répondre',
    loadMore: 'Charger plus',
    edited: 'Modifié',
    noComments: "Il n'y a pas encore de commentaires",
    leaveFirstComment: 'Vous pouvez laisser le premier'
  },
  curtain: {
    close: 'Fermer'
  },
  photoPreview: {
    close: 'Fermer'
  },
  photoCropper: {
    back: 'Retour',
    save: 'Enregistrer'
  },
  rightSidebar: {
    in: 'dans'
  },
  pushPrompt: {
    title: '“{appName}” souhaiterait vous envoyer des notifications',
    description:
      "Les notifications peuvent inclure des alertes, des sons et des badges d'icône. Ils peuvent être configurés dans Paramètres.",
    later: 'Demander plus tard',
    neverLater: 'Ne plus jamais demander',
    allow: 'Autoriser'
  },
  inAppPush: {
    attachment: 'Pièce jointe'
  },
  installPrompt: {
    android: {
      install: 'Installer',
      description:
        "Pour une expérience transparente, vous n'avez pas besoin d'utiliser un navigateur. Installez-le simplement comme une application.",
      press: 'Appuyez sur',
      andSelect: 'et sélectionnez',
      orSimply: 'ou simplement',
      description2: 'cliquez sur le bouton Installer ci-dessous',
      notNow: 'Pas maintenant'
    },
    ios: {
      justTap: 'Appuyez sur le',
      buttonInBrowser: 'bouton « Plus » dans votre navigateur et sélectionnez « Partager »',
      addToHomeScreen: 'Faites défiler vers le bas et appuyez sur « Sur l\'écran d\'accueil », puis cliquez sur « Ajouter »',
      appWillBeInstalled: "L'application sera ajoutée à votre écran d'accueil"
    },
    installApp: "Installer l'application",
    useWeb: 'Utiliser la version web'
  },
  footer: {
    more: 'Menu'
  },
  menu: {
    installApp: "Installer l'application",
    menu: 'Menu',
    close: 'Fermer'
  },
  404: {
    whoops: 'Oups!',
    description:
      "Il semble que la page n'existe pas ou peut-être que vous n'y avez pas accès. Veuillez contacter le propriétaire de l'application pour plus de détails.",
    ok: 'OK'
  },
  relatedUsers: {
    seeall: 'Voir tout'
  },
  networkingCurtain: {
    'newOneOnOne': 'Nouveau 1:1',
    'details': 'Détails',
    'coverMessage': 'Message de couverture',
    'location': 'Emplacement',
    'duration': 'Durée',
    '15min': '15 min',
    '30min': '30 min',
    '45min': '45 min',
    '60min': '60 min',
    'timeSlot': 'Créneau horaire',
    'sendInvitation': "Envoyer l'invitation",
    'success': 'Succès',
    'invitationSent':
      "Vous avez envoyé avec succès l'invitation à une rencontre 1:1. Voulez-vous rester sur cette page ou naviguer vers toutes vos réunions 1:1 programmées ?",
    'seeAll': 'Voir toutes les réunions 1:1',
    'stayHere': 'Rester ici'
  },
  networking: {
    level: {
      1: 'Pas encore prêt à réseauter. Aucune activité ou engagement significatif.',
      2: 'Rarement actif ou manque des informations clés dans le profil, ce qui rend difficile la connexion avec les autres.',
      3: 'Profil complété avec photo et en ligne, entièrement prêt à commencer à réseauter.',
      4: "En train de prendre de l'élan - a initié au moins une connexion au cours des 6 dernières heures.",
      5: "Un maître du réseautage - répond activement aux demandes et s'engage avec les autres dans les 6 dernières heures."
    }
  },
  time: {
    days: 'j',
    hours: 'h',
    minutes: 'm',
    seconds: 's',
    startsIn: 'dans',
    Today: "Aujourd'hui",
    today: "aujourd'hui",
    Tomorrow: 'Demain',
    tomorrow: 'demain',
    Yesterday: 'Hier',
    yesterday: 'hier',
    startingNow: 'commence maintenant'
  },
  daysMonths: {
    months: "['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre']",
    monthsShort: "['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc']",
    weekdays: "['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi']",
    weekdaysShort: "['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']",
    weekdaysMin: "['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa']"
  },
  badges: {
    legend: 'Legendary Networker',
    push: 'Online and Trusted',
    leader: 'Leaderboard Champ',
    meetmaster: '1:1 Meeting Master',
    connector: '3-Time Connector',
    legend_description:
      'Atteindre le niveau Légende au moins une fois en réseautant activement et en établissant des connexions significatives.',
    push_description: 'Activez les notifications push pour rester réactif et ne jamais manquer une occasion.',
    leader_description: 'Atteignez au moins une fois le top 10 % du classement.',
    meetmaster_description: "Initier ou répondre à au moins une demande de réunion 1:1 dans l'application.",
    connector_description: "Établir au moins trois connexions via l'application pendant les composants."
  }
}
